import React, { Component } from 'react';
import Slider from 'react-slick';

class Gallery extends Component {
	render() {
		var settings = {
            speed: 5000,
			autoplay: true,
			autoplaySpeed: 0,
		    slidesToShow: 3.5,
		    arrows: false,
		  	slidesToScroll: 1,
		    infinite: true,
		    swipeToSlide: false,
		  	centerMode: true,
		  	responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2.5,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1.5,
				}
			}
			]
		};
		return (
			<section className="gallery">
				<div className="gallery__slider">
					<Slider {...settings}>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery1.png" alt="" />
						</div>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery2.png" alt="" />
						</div>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery3.png" alt="" />
						</div>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery4.png" alt="" />
						</div>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery1.png" alt="" />
						</div>
						<div className="gallery__slider--single">
							<img src="images/gallery/gallery2.png" alt="" />
						</div>
					</Slider>
				</div>
			</section>
		);
	}
}


export default Gallery